/* eslint-disable */
export default {
  en: [
    {
      name: 'Alen Salamun',
      username: 'AlenSalamun',
      link: 'https://twitter.com/AlenSalamun',
      logo: 'twitter',
      photo: 'alen salamun.jpg',
      comment:
        'Simple, they take security serious. Meaning serious SOC with appropriate detection mechanisms to detect even user side attacks as phishing very quickly! @binance really stands out of that field!',
    },
    {
      name: 'CryptoRich',
      username: 'KEBKR',
      link: 'https://twitter.com/KEBKR',
      logo: 'twitter',
      photo: 'CryptoRich_.jpg',
      comment:
        'It’s very simple. Ease of access and ease of use. They are continually building and engage customers directly on social media every time there’s any kind of bump in the road (funds are safu).',
    },
    {
      name: 'Zeitgeist‏',
      username: 'thsigit',
      link: 'https://twitter.com/thsigit',
      logo: 'twitter',
      photo: 'Zeitgeist_.jpg',
      comment:
        "Innovations: new product launch / new initiatives (including charities, which prove that binance isn't only about profit --which is acceptable-- but also about development and humanity). Hope that all crypto companies will follow.",
    },
    {
      name: 'Crypto Quantamental',
      username: 'CryptoQF',
      link: 'https://twitter.com/CryptoQF',
      logo: 'twitter',
      photo: 'Crypto Quantamental.jpg',
      comment:
        'I had an urgent need for a booster verification. The queue would have had me wait days at minimum. I reached out to a rep, explained my situation, and verified me immediately. Stuff like that creates a lot of good will.',
    },
    {
      name: 'Markus',
      username: 'markusjayvc',
      link: 'https://twitter.com/markusjayvc',
      logo: 'twitter',
      photo: 'Markus_.jpg',
      comment:
        "Because the Binance ecosystem is pushing for global crypto adoption on all fronts: Labs, Academy, Research & Charity. They are doing a lot for crypto adoption, and that's not even mentioning their globally leading exchange or @cz_binance.",
    },
    {
      name: 'sourcex',
      username: 'sourcex44',
      link: 'https://twitter.com/sourcex44',
      logo: 'twitter',
      photo: 'sourcex_.jpg',
      comment:
        "What i appreciate most about Binance is: - Customer Service - A role model in cz - Mobile app (it's beautiful) - Community - Transparency - Binance Charity - Now, fiat to crypto ",
    },
  ],
  cn: [
    {
      name: '币圈小鸠',
      username: '币圈小鸠',
      link: 'https://weibo.com/u/6481957776',
      logo: 'weibo',
      photo: 'xiaojiu.jpg',
      comment:
        'BINANCE是交易所中的战斗机，智慧得榜样，行业楷模。务实+初心，相信BINANCE会圆满完成他们一个个小目标！',
    },
    {
      name: '长大爱吃菜',
      username: '长大爱吃菜',
      link: 'https://weibo.com/u/2014802247',
      logo: 'weibo',
      photo: 'chicai.jpg',
      comment: '愿币安以后来居上的实力，潜心于底层技术，为世界提供更好的交易平台，为伟大负重前行！',
    },
    {
      name: '未来空间方程式',
      username: '未来空间方程式',
      link: 'https://weibo.com/u/1976542861',
      logo: 'weibo',
      photo: 'fangchengshi.jpg',
      comment: '信赖追求质量、注重细节成分的平台，币安，加油！',
    },
  ],
  tw: [
    {
      name: '币圈小鸠',
      username: '币圈小鸠',
      link: 'https://weibo.com/u/6481957776',
      logo: 'weibo',
      photo: 'xiaojiu.jpg',
      comment:
        'BINANCE是交易所中的戰鬥機，智慧得榜樣，行業楷模。務實+初心，相信BINANCE會圓滿完成他們一個個小目標！',
    },
    {
      name: '',
      username: '长大爱吃菜',
      link: 'https://weibo.com/u/2014802247',
      logo: 'weibo',
      photo: 'chicai.jpg',
      comment: '願幣安以後來居上的實力，潛心於底層技術，為世界提供更好的交易平臺，為偉大負重前行！',
    },
    {
      name: '未来空间方程式',
      username: '未来空间方程式',
      link: 'https://weibo.com/u/1976542861',
      logo: 'weibo',
      photo: 'fangchengshi.jpg',
      comment: '信賴追求質量、注重細節成分的平臺，幣安，加油！',
    },
  ],
  vn: [
    {
      name: 'Quyet Huynh',
      username: 'mr.quyethuynh',
      link: 'https://www.facebook.com/mr.quyethuynh',
      logo: 'facebook',
      photo: 'Quyet Huynh.jpg',
      comment:
        'Binance là sàn lớn hiện nay trong thị trường crypto, dẫn đầu trend mới IEO, các dự án được đánh giá kỹ bởi đội ngũ nghiên cứu giàu kinh nghiệm, giúp các nhà đầu tư yên tâm và đặt niềm tin vào Binance cũng như đồng BNB',
    },
    {
      name: 'Thiều Hưng',
      username: 'thieuhung2018',
      link: 'https://www.facebook.com/thieuhung2018',
      logo: 'facebook',
      photo: 'ThieuHung.jpg',
      comment: 'Thật tuyệt vời. Chưa có một sàn nào lại lo cho nhà đầu tư như vậy. Tks. #Binance',
    },
    {
      name: 'Runningman-MU',
      username: 'liveabetterlife',
      link: '#',
      logo: 'telegram',
      photo: 'Runningman-MU.jpg',
      comment:
        'Từ khi biết Binance thì chỉ khoái trade ở đây, quên luôn mấy sàn kia. Uy tín và chất lượng luôn đi đầu',
    },
  ],
  es: [
    {
      name: 'Cristian Rios Medrano',
      username: 'cristian.riosmedrano',
      link: 'https://www.facebook.com/cristian.riosmedrano',
      logo: 'facebook',
      photo: 'es4.jpg',
      comment:
        'Recomiendo comprar su moneda ya que es una de las mejors decisiones que yo he hecho por la seriedad del proyecto por el futuro que tiene y lo estrategico que han sido con su moneda.',
    },
    {
      name: 'Noel Saavedra',
      username: 'noeljsaavedra',
      link: 'https://www.facebook.com/noeljsaavedra',
      logo: 'facebook',
      photo: 'es5.jpg',
      comment:
        'Entre los mejores exchange que hay actualmente, muy seguro y con una atención 10/10 ¡100% recomendado!',
    },
    {
      name: 'Jaime Fajar Fernandez',
      username: 'jaime.fajarfernandez',
      link: 'https://www.facebook.com/jaime.fajarfernandez',
      logo: 'facebook',
      photo: 'es3.jpg',
      comment:
        'El top 1 en exchanges. Siempre tratando de mojarar la experiencia con sus usuarios. ¡El mejor sin duda!',
    },
    {
      name: 'Manu Gómez',
      username: 'noeljsaavedra',
      link: 'https://www.facebook.com/noeljsaavedra',
      logo: 'facebook',
      photo: 'es1.jpg',
      comment: 'Exceñemte Exchange y com muy buena atención al usuario además de intuitiva.',
    },
    {
      name: 'Silva A. Ferth',
      username: 'ferth',
      link: 'https://www.facebook.com/ferth',
      logo: 'facebook',
      photo: 'es2.jpg',
      comment: 'Excelente exchange con las mejores criptomonedas del mercado.',
    },

    {
      name: 'Erick Torrealba',
      username: 'erick.torrealba.5891',
      link: 'https://www.facebook.com/erick.torrealba.5891',
      logo: 'facebook',
      photo: 'es6.jpg',
      comment: 'De los exchanges mas confiables en todo el inicio del ecosistema criptografico.',
    },
  ],
  kr: [
    {
      name: 'blakejeong727',
      username: 'blakejeong7271',
      link: 'https://twitter.com/blakejeong7271',
      logo: 'twitter',
      photo: 'blakejeong727.jpg',
      comment:
        ':제가 다양한 거래소를 사용해봤지만 바이낸스처럼 기술적으로 안정적이고 일처리가 빠른 거래소는 없었습니다. 세계 최고의 거래소라는 말이 허언이 아닙니다. 또, 최고의 위치에 있음에도 텔레그램을 통해 항상 사용자들과 소통하는 모습도 인상적입니다.',
    },
    {
      name: 'Seungjae Andrew Kang',
      username: 'Andrew_KSJ',
      link: 'https://twitter.com/Andrew_KSJ',
      logo: 'twitter',
      photo: 'Seungjae Andrew Kang.jpg',
      comment:
        ':바이낸스가 출시 이후 실거래량 1위를 확실히 지키고 있는데는 이유가 있다고 생각합니다. 편리한 UI/UX, 최고의 CS, 거래 가능한 토큰의 수 등등... 오는 17일날 바이낸스의 밋업이 매우 기대됩니다!ㅎㅎ',
    },
    {
      name: '이영인',
      username: 'yeong___in',
      link: 'https://twitter.com/yeong___in',
      logo: 'twitter',
      photo: 'hanguo3.jpg',
      comment:
        '바이낸스! 트레이딩하기 편하고, 무엇보다 한 눈에 크립토 시황을 파악할 수 있어서 좋습니다. 역시나 세계 1등 거래소.... 17일 한국에서 열리는 밋업도 기대되네요. 꼭 참여할 예정입니다',
    },
  ],
  it: [
    {
      name: 'Vlad Golub',
      username: 'vladgolub1996',
      link: 'https://twitter.com/vladgolub1996',
      logo: 'twitter',
      photo: 'Vlad Golub.jpg',
      comment:
        'il servizio di @binance per le carte di credito è una bomba!  Comodo, veloce, tutto incluso: compero le cripto con un click direttamente su #binance. Per favorire l’adozione delle cripto nel mondo Binance è il top.',
    },
    {
      name: 'Alessandro Preti',
      username: 'BTCwolf',
      link: 'https://twitter.com/BTCwolf',
      logo: 'twitter',
      photo: 'Alessandro Preti.jpg',
      comment:
        'Fare trading su #Binance è come giocare una partita, dove il campo è tutto il mondo e i giocatori sono più di 10 milioni. Uno sport fatto di concentrazione, disciplina e adrenalina! #BinanceIsGlobal',
    },
    {
      name: 'stefano',
      username: 'stefanencko_90',
      link: 'https://twitter.com/stefanencko_90',
      logo: 'twitter',
      photo: 'stefano.jpg',
      comment:
        "L'istruzione e la formazione nel settore crypto sono una grande barriera all'entrata, ma grazie a Binance, ed in particolare alla divisione Academy, la conoscenza è a disposizione di tutti! #Binance #BinanceAcademy",
    },
    {
      name: 'Michele Zilocchi',
      username: 'MicheleZilocchi',
      link: 'https://twitter.com/MicheleZilocchi',
      logo: 'twitter',
      photo: 'Michele Zilocchi.jpg',
      comment:
        'Perchè mi piace @binance ? Per la semplicità di utlizzo, la moltitudine di mercati e perchè non è solo un Exchange, ma un vero e proprio crypto- ecosistema ed è anche per questo motivo che il nostro team lo ha scelto per farci trading professionale.',
    },
    {
      name: 'Andrew Bit',
      username: 'AndrewBIT101',
      link: 'https://twitter.com/AndrewBIT101',
      logo: 'twitter',
      photo: 'Andrew Bit.jpg',
      comment:
        'Prova #trustwallet, il wallet di #Binance totalmente decentralizzo e sperimenta la sicurezza di avere tu il controllo totale delle tue chiavi private. Per saperne di più su questo argomento e molto altro vieni a trovarci a #Pescara il 30 Marzo dalle ore 16 alle 18.$BNB',
    },
    {
      name: 'Paolo',
      username: 'Paolo_crypto',
      link: 'https://twitter.com/Paolo_crypto',
      logo: 'twitter',
      photo: 'Paolo.jpg',
      comment:
        '@binance mi permette di fare trading su un alto numero di cryptovalute e token in modo facile e veloce. Le commissioni sulle transazioni sono tra le più basse sul mercato e la sicurezza è uno dei cavalli di battaglia della società. Super consigliato! #Binance #Crypto #bitcoin',
    },
  ],
};
